import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["name", "scale", "size"];
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.function.name.js";
import React, { forwardRef } from 'react';
import iconMap from 'components/icons/iconMap';
var sizeMap = {
  unscaled: 0,
  default: 1,
  medium: 1.5,
  big: 3,
  huge: 6
};
export function isIconName(token) {
  if (typeof token !== 'string') return false;
  return Object.keys(iconMap).includes(token);
}
var Icon = /*#__PURE__*/forwardRef(function (props, ref) {
  var name = props.name,
    scale = props.scale,
    size = props.size,
    otherProps = _objectWithoutProperties(props, _excluded);
  var Glyph = iconMap[name];
  var hasScale = scale !== null && scale !== undefined;
  var fallbackSize = size ? sizeMap[size] : 1;
  if (!Glyph) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Glyph, _extends({
    ref: ref,
    scale: hasScale ? scale : fallbackSize
  }, otherProps));
});
Icon.displayName = 'Icon';
export default Icon;